import { useTranslation } from 'react-i18next'
import { cn } from '../../lib/utils'

export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n } = useTranslation()

  const languages = [
    { code: 'es', label: 'ES' },
    { code: 'en', label: 'EN' },
  ]

  return (
    <div className={cn('flex items-center rounded-full border border-border-subtle bg-surface p-1', className)}>
      {languages.map((lang) => (
        <button
          key={lang.code}
          type="button"
          onClick={() => i18n.changeLanguage(lang.code)}
          className={cn(
            'px-3 py-1 text-xs font-medium rounded-full transition-all',
            i18n.language === lang.code
              ? 'bg-accent text-white'
              : 'text-text-secondary hover:text-text-primary',
          )}
          aria-pressed={i18n.language === lang.code}
        >
          {lang.label}
        </button>
      ))}
    </div>
  )
}
